export default "__VITE_ASSET__DGrVFXFm__"